<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">用户复购周期</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="4">
        <el-date-picker
          v-model="arrTime"
          align="right"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          class="header-item"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="3">
        <el-select
          style="width: 240px"
          v-model="channel"
          placeholder=""
          multiple
          collapse-tags
          @change="lifeCycleChannelChange"
        >
          <el-option
            v-for="(item, itemIndex) in channels"
            v-bind:key="itemIndex"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>

      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        stripe
        border
      >
        <el-table-column prop="date" fixed label="日期" width="100">
        </el-table-column>
        <el-table-column prop="channel" fixed label="渠道" width="100">
        </el-table-column>
        <el-table-column prop="topUpsToday" label="3. 当天充值人数" width="110">
        </el-table-column>
        <el-table-column
          prop="totalOfRepurchase"
          label="4.复购总人数"
          width="110"
        >
        </el-table-column>
        <el-table-column prop="rate43" label="4/3占比" width="110">
        </el-table-column>
        <el-table-column
          prop="todayRepurchase"
          label="5.当天复购人数"
          width="110"
        >
        </el-table-column>
        <el-table-column prop="rate54" label="5/4占比" width="110">
        </el-table-column>
        <el-table-column
          prop="oneDayApart"
          label="6.间隔1天复购人数"
          width="130"
        >
        </el-table-column>
        <el-table-column prop="rate64" label="6/4占比" width="110">
        </el-table-column>
        <el-table-column
          prop="twoDaysApart"
          label="7.间隔2天复购人数"
          width="130"
        >
        </el-table-column>
        <el-table-column prop="rate74" label="7/4占比" width="110">
        </el-table-column>
        <el-table-column
          prop="threeDaysApart"
          label="8.间隔3天复购人数"
          width="130"
        >
        </el-table-column>
        <el-table-column prop="rate84" label="8/4占比" width="110">
        </el-table-column>
        <el-table-column
          prop="fourDaysApart"
          label="9.间隔4天复购人数"
          width="130"
        >
        </el-table-column>
        <el-table-column prop="rate94" label="9/4占比" width="110">
        </el-table-column>
        <el-table-column
          prop="fiveDaysApart"
          label="10.间隔5天复购人数"
          width="130"
        >
        </el-table-column>
        <el-table-column prop="rate104" label="10/4占比" width="110">
        </el-table-column>
        <el-table-column
          prop="sixDaysApart"
          label="11.间隔6天复购人数"
          width="130"
        >
        </el-table-column>
        <el-table-column prop="rate114" label="11/4占比" width="110">
        </el-table-column>
        <el-table-column
          prop="sevenDaysApart"
          label="12.间隔7天复购人数"
          width="130"
        >
        </el-table-column>
        <el-table-column prop="rate124" label="12/4占比" width="110">
        </el-table-column>
        <el-table-column
          prop="moreThanSevenDays"
          label="13.间隔超过7天复购人数"
          width="130"
        >
        </el-table-column>
        <el-table-column prop="rate134" label="13/4占比" width="110">
        </el-table-column>
        <el-table-column
          prop="moreThanThirtyDays"
          label="14.间隔超过30天复购人数"
          width="130"
        >
        </el-table-column>
        <el-table-column prop="rate144" label="14/4占比" width="110">
        </el-table-column>
      </el-table>
    </el-row>
    <!-- <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="30"
      ></el-pagination>
    </el-row> -->
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry } from '@/utils/normalApi.js'

export default {
  data() {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      arrTime: datainfor(1),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      //   page: 1,
      //   total: 0,
      // 表格数据
      dayChatDetailData: [],
      channel: ['total'],
      channels: this.$store.state.channels
    }
  },
  async created() {
    await this._getCountry()
    this.getDayChatDetai()
  },
  methods: {
    lifeCycleChannelChange(currentVal) {
      const currentValLen = currentVal.length
      if (currentValLen === 2) {
        if (currentVal[0] === 'total' || currentVal[0] === 'all') {
          this.channel = [currentVal[currentValLen - 1]]
        }
      }
      if (currentValLen !== 1) {
        if (
          currentVal[currentValLen - 1] === 'total' ||
          currentVal[currentValLen - 1] === 'all'
        ) {
          this.channel = [currentVal[currentValLen - 1]]
        }
      }
    },
    async _getCountry() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },

    // 查询列表
    async getDayChatDetai() {
      this.login1 = true

      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.repurchase_cycle,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          date: this.arrTime,
          channel: this.channel.join(',')
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data
      //   this.total = res.data.total;
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.repurchase_cycle_dow,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          date: this.arrTime,
          channel: this.channel.join(',')
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '主播流量总览数据' + this.arrTime)
    },
    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  .el-col {
    display: flex;
    align-items: center;

    >div {
      margin-right: 5px;
    }
  }

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
